﻿import $ from "jquery";

$(() => {
    var currentPage = $("#currentPage").val();
    if (currentPage != "contactDetail") return;

});

